require('./cardRequestAdditionalStep2.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @ commons
const { FormattedText } = require('core/i18n').i18n;

// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @ utilities
const { intervenerNameIsEmpty, getFullName, intervenerAddressIsEmpty, getFormattedAddress } = require('utilities/contactCenter/intervenerDataHelper');

class CardRequestAdditionalStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { immCard, immStep } = this.props;
        const cardBeneficiaryName = immCard.get('beneficiaryName');
        const cardType = immStep.get('cardType');
        const cardNumber = immCard.get('number');
        const immValidateServiceResponse = immStep.get('validateServiceResponse');
        const intervenerName = intervenerNameIsEmpty(immValidateServiceResponse) ? '--' : getFullName(immValidateServiceResponse);
        const intervenerAddress = intervenerAddressIsEmpty(immValidateServiceResponse) ? '--' : getFormattedAddress(immValidateServiceResponse);

        return (
            <div className="card-request-additional-step-2">
                <h4 className="card-request-additional-step-2__title wizard-step--vertical__title">
                    <FormattedText value="cardRequestAdditionalStep2-title" />
                </h4>
                <div className="card-request-additional-step-2__subtitle wizard-step--vertical__sub-title">
                    <FormattedText value="cardRequestAdditionalStep2-subtitle" />
                </div>
                <div className="card-request-additional-step-2__body" id="printable-wizard">
                    <BlockInfo>
                        <p>
                            <FormattedText
                                className="card-request-additional-step-2__confirmation-script"
                                value="cardRequestAdditionalStep2-confirmationScriptPart1"
                            />
                            <span className="card-request-additional-step-2__confirmation-script--strong">{cardBeneficiaryName}</span>
                        </p>
                        <br/>
                        <p>
                            <FormattedText
                                className="card-request-additional-step-2__confirmation-script"
                                value="cardRequestAdditionalStep2-confirmationScriptPart2"
                                injectedStrings={[ cardType, intervenerName, cardType, cardNumber ]}
                            />
                        </p>
                        <br/>
                        <p>
                            <FormattedText
                                className="card-request-additional-step-2__confirmation-script"
                                value="cardRequestAdditionalStep2-confirmationScriptPart3"
                            />
                            <span className="card-request-additional-step-2__confirmation-script--strong">{intervenerAddress}</span>
                        </p>
                        <br/>
                        <p>
                            <FormattedText
                                className="card-request-additional-step-2__confirmation-script"
                                value="cardRequestAdditionalStep2-confirmationScriptPart4"
                                injectedStrings={[ cardBeneficiaryName ]}
                            />
                        </p>
                    </BlockInfo>
                </div>
            </div>
        );
    }
}

CardRequestAdditionalStep2.propTypes = {
    immCard: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
}

module.exports = CardRequestAdditionalStep2;
